module.exports = __webpack_public_path__ + "img/3KFKwAYgHBq6YbCiBeyMZQ.842e02fd.svg";